import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { CostSubtotalEditorViewModel, CreateCostSubtotalEventPayload, RenameCostSubtotalEventPayload } from '@Quest/Financials/Costs/Components/CostSubtotalEditor';
import CostSubtotalEditor from "@Quest/Financials/Costs/Components/CostSubtotalEditor.vue";
import { CreateExpenseAccountEventPayload, ExpenseAccountEditorViewModel, UpdateCostAccountEventPayload } from '@Quest/Financials/Costs/Components/ExpenseAccountEditor';
import ExpenseAccountEditor from "@Quest/Financials/Costs/Components/ExpenseAccountEditor.vue";
import { CreateCostSubtotalCommandV1, CreateExpenseAccountCommandV1, DeleteCostSubtotalCommandV1, DeleteExpenseAccountCommandV1, RenameCostSubtotalCommandV1, UpdateCostAccountCommandV1 } from '@Quest/Financials/Costs/Domain/commands-core';
import CostsCommands from '@Quest/Financials/Costs/Domain/commands-vue-component';
import CostsQueries from '@Quest/Financials/Costs/Domain/queries-vue-component';
import { CostAccountReadModel, CostSubtotalReadModel, CostsReadModel } from '@Quest/Financials/Costs/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';

@Component({
    components: {
        CorporateNavigation, CostSubtotalEditor, ExpenseAccountEditor
    }
})
export default class CostsPage extends mixins(CostsCommands, CostsQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: CostsReadModel | null = null;

    costSubtotalEditor = new CostSubtotalEditorViewModel();
    expenseAccountEditor = new ExpenseAccountEditorViewModel();

    get costs() { return this.rm?.Costs ?? []; }
    get subtotals() { return this.rm?.Subtotals ?? []; }
    get standaloneCosts(): CostAccountReadModel[] { return this.costs.filter(a => a.IsStandalone); }

    mounted()
    {
        document.title = "Costs | TransparentChoice";
        this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
    }

    showExpenseCreator(parentSubtotalId: string | null)
    {
        this.expenseAccountEditor.showCreator(parentSubtotalId, this.subtotals);
    }

    showExpenseEditor(e: CostAccountReadModel)
    {
        this.expenseAccountEditor.showEditor(e.Id, e.Name, e.Classification, e.SubtotalId, e.CanEditName, e.CanEditClassification, this.subtotals);
    }

    showSubtotalEditor(s: CostSubtotalReadModel)
    {
        this.costSubtotalEditor.showEditor(s.Id, s.Name);
    }

    showSubtotalCreator()
    {
        this.costSubtotalEditor.showCreator();
    }

    handleCreateExpenseAccountCommand(e: CreateExpenseAccountEventPayload)
    {
        this.invokeCreateExpenseAccountCommandV1(this.workspaceId, this.strategyId, guid(), e.name, null, e.classification, e.subtotalId);
    }

    hanldeUpdateCostAccountCommand(e: UpdateCostAccountEventPayload)
    {
        this.invokeUpdateCostAccountCommandV1(this.workspaceId, this.strategyId, e.id, e.name, null, e.classification, e.subtotalId);
    }

    handleDeleteExpenseAccountCommand(expense: CostAccountReadModel)
    {
        if (expense.CanDelete)
        {
            if (confirm("Are you sure?") === true)
            {
                this.invokeDeleteExpenseAccountCommandV1(this.workspaceId, this.strategyId, expense.Id);
            }
        }
        else
        {
            alert("Can't delete this type of cost");
        }
    }


    handleCreateCostSubtotalCommand(e: CreateCostSubtotalEventPayload)
    {
        this.invokeCreateCostSubtotalCommandV1(this.workspaceId, this.strategyId, guid(), e.name);
    }

    handleRenameCostSubtotalCommand(e: RenameCostSubtotalEventPayload)
    {
        this.invokeRenameCostSubtotalCommandV1(this.workspaceId, this.strategyId, e.id, e.name);
    }

    handleDeleteCostSubtotalCommand(subtotal: CostSubtotalReadModel)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteCostSubtotalCommandV1(this.workspaceId, this.strategyId, subtotal.Id);
        }
    }


    onSetModel(model: any, modelName: string)
    {
        if (modelName === "CostsReadModel")
        {
            this.rm = model as CostsReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateExpenseAccountCommandV1.matchType(cmd))
        {
            this.expenseAccountEditor.close();
            this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
        }
        else if (UpdateCostAccountCommandV1.matchType(cmd))
        {
            this.expenseAccountEditor.close();
            this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
        }
        else if (DeleteExpenseAccountCommandV1.matchType(cmd))
        {
            this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
        }
        else if (CreateCostSubtotalCommandV1.matchType(cmd))
        {
            this.costSubtotalEditor.close();
            this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
        }
        else if (RenameCostSubtotalCommandV1.matchType(cmd))
        {
            this.costSubtotalEditor.close();
            this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
        }
        else if (DeleteCostSubtotalCommandV1.matchType(cmd))
        {
            this.runManageCostsPageQueryV1(this.workspaceId, this.strategyId);
        }
    }
}